__turbopack_context__.v({
  "h1": "GrArticle-module__G498sq__h1",
  "inner": "GrArticle-module__G498sq__inner",
  "page": "GrArticle-module__G498sq__page",
  "prose": "GrArticle-module__G498sq__prose",
});
